import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExport = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 15,
	height: 15,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 3v12M7 10l5 5 5-5M4 19h16" })
});
export default SvgExport;
